export enum DocumentEnum {

    personal = 1,
    general
}
